import type { PocInputValidity } from 'commons/types';
import { ErrorMapping } from 'core/types/error-mapping';
import { showErrorNotification } from 'core/utils/notification-service';
import { ErrorType, ValidationState } from '../domain';

export const handleErrors = <E extends ErrorType, TErrorCode extends string = string>(
    errorString: Error,
    errorsMappings: ErrorMapping<TErrorCode>[],
    setErrors: (errors: E['errors']) => void,
    setValidation: React.Dispatch<React.SetStateAction<ValidationState>>,
    notificationError?: string
): boolean => {
    let resolveError = false;

    const error = JSON.parse(errorString.message) as E;
    if (error.errors?.length > 0 && error.errors[0].extensions.code !== 'UNHANDLED_EXCEPTION') {
        setErrors(error.errors);

        setValidation((prevValidation) => {
            const newValidationState = { ...prevValidation };

            const errorUpdates = error.errors.reduce<ValidationState>((acc, e) => {
                const errorMapping = errorsMappings.find(({ errorCode }) => errorCode === e.extensions.code);
                return errorMapping?.field
                    ? { ...acc, [errorMapping.field]: { state: 'error', type: ['custom'] } as PocInputValidity }
                    : acc;
            }, {});

            return { ...newValidationState, ...errorUpdates };
        });
    } else {
        if (notificationError) {
            showErrorNotification(notificationError);
        }
        resolveError = true;
    }

    return resolveError;
};
